// extracted by mini-css-extract-plugin
export var cols = "Container-module--cols--2QN5L";
export var left = "Container-module--left--3d8l7";
export var right = "Container-module--right--2rHna";
export var simple = "Container-module--simple--yomfY";
export var sides = "Container-module--sides--2SzLm";
export var simpleContent = "Container-module--simpleContent--1gzUQ";
export var sidesContent = "Container-module--sidesContent--1px9E";